import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CONFIG from '@/config';

const stripePublicKey = CONFIG.STRIPE_PUBLIC_KEY;

const stripePromise = loadStripe(stripePublicKey);

export const StripeContextProvider: React.FC = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
